import reducer from "./reducer";
import { createContext, useReducer } from "react";

//Context and Provider
export const AppContext = createContext();

const Provider = ({ children }) => {
  const initialState = {
    search: "",
    cart_qty: 0,
    wishlist_qty: 0,
    show_mobile_search: false,
    tax_expiry:"",
    tob_expiry:"",
    is_authenticated: localStorage.getItem("is_authenticated")||0,
  };

  const actions = {
    SET_SEARCH: "SET_SEARCH",
    SET_CART_QTY: "SET_CART_QTY",
    SET_WISHLIST_QTY: "SET_WISHLIST_QTY",
    SET_IS_AUTHENCTICATED: "SET_IS_AUTHENTICATED",
    SHOW_MOBILE_SEARCH: "SHOW_MOBILE_SEARCH",
    SET_TAX_EXPIRY: "SET_TAX_EXPIRY",
    SET_TOB_EXPIRY: "SET_TOB_EXPIRY",
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const value = {
    search: state.search,
    cart_qty: state.cart_qty,
    wishlist_qty: state.wishlist_qty,
    is_authenticated: state.is_authenticated,
    show_mobile_search: state.show_mobile_search,
    tax_expiry: state.tax_expiry,
    tob_expiry: state.tob_expiry,

    setSearch: (query) => {
      dispatch({ type: actions.SET_SEARCH, query });
    },

    setCartQty: (qty) => {
      dispatch({ type: actions.SET_CART_QTY, qty });
    },

    setWishlistQty: (qty) => {
      dispatch({ type: actions.SET_WISHLIST_QTY, qty });
    },

    setIsAuthenticated: (value) => {
      dispatch({ type: actions.SET_IS_AUTHENCTICATED, value });
    },

    setShowMobileSearch: (value) => {
      dispatch({ type: actions.SHOW_MOBILE_SEARCH, value });
    },

    setTaxExpiry: (value) => {
      dispatch({ type: actions.SET_TAX_EXPIRY, value });
    },
    setTobExpiry: (value) => {
      dispatch({ type: actions.SET_TOB_EXPIRY, value });
    },
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default Provider;
